var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { ApTextFieldGridItem } from "../../../shared/components/forms/ApTextFieldGridItem";
import { useFormik } from "formik";
import PlayIcon from '@mui/icons-material/PlayCircleOutline';
import * as yup from "yup";
import { FormConstants } from "../../../shared/components/forms/Constants";
import { enqueueSnackbar } from "notistack";
import { getErrorMessage } from "../../../utilities/axios-utility";
import { errorSnackbar } from "../../../shared/snackbar-constants";
import { useTranslation } from "react-i18next";
export var NuveiP24PayPage = function (_a) {
    var paymentSessionId = _a.paymentSessionId, setPaymentResult = _a.setPaymentResult, geoData = _a.geoData, setPaymentResultOpened = _a.setPaymentResultOpened, setPaymentInProgress = _a.setPaymentInProgress, api = _a.api;
    var countries = geoData.countries;
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var processorCommonCode = "NVA008";
    var emptyConfig = {
        cardNumber: "",
        city: "",
        country: "",
        cvc: "",
        dateOfBirth: null,
        email: "",
        expiryDate: "",
        name: "",
        phoneNumber: "",
        state: "",
        street: "",
        surname: "",
        zip: ""
    };
    var ValidationScheme = yup.object({
        name: yup.string().required(t(FormConstants.FieldIsRequired)),
        surname: yup.string().required(t(FormConstants.FieldIsRequired)),
        country: yup.string().typeError(t(FormConstants.FieldIsRequired)).required(t(FormConstants.FieldIsRequired)).nullable(),
        email: yup.string().email(t("email must be a valid email")).required(t(FormConstants.FieldIsRequired)),
    });
    var formik = useFormik({
        initialValues: emptyConfig,
        validationSchema: ValidationScheme,
        enableReinitialize: true,
        onSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
            var request, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = {
                            processorCommonCode: processorCommonCode,
                            paymentSessionId: paymentSessionId,
                            email: values.email,
                            name: values.name,
                            surname: values.surname,
                            country: values.country
                        };
                        setPaymentInProgress(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        setPaymentResultOpened(true);
                        return [4 /*yield*/, api.OpenPayment(request)];
                    case 2:
                        response = _a.sent();
                        setPaymentResult(response.data);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        setPaymentInProgress(false);
                        enqueueSnackbar(getErrorMessage(error_1), errorSnackbar);
                        return [3 /*break*/, 4];
                    case 4:
                        setPaymentInProgress(false);
                        return [2 /*return*/];
                }
            });
        }); }
    });
    var onSubmit = function () {
        formik.handleSubmit();
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsx(ApTextFieldGridItem, { name: 'name', label: t('Name'), required: true, formik: formik, xs: 6, foolWidth: true, size: 'small', sx: { minWidth: 300, padding: 2 } }), _jsx(ApTextFieldGridItem, { name: 'surname', label: t('Surname'), required: true, formik: formik, xs: 6, foolWidth: true, size: 'small', sx: { minWidth: 300, padding: 2 } })] })), _jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsx(ApTextFieldGridItem, { name: 'email', label: t('Email'), required: true, formik: formik, xs: 6, foolWidth: true, size: 'small', sx: { minWidth: 300, padding: 2 } }), _jsx(Grid, __assign({ item: true, xs: 6, sx: { minWidth: 300, padding: 2 } }, { children: _jsx(Autocomplete, { disablePortal: true, options: countries, size: 'small', renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { required: true, error: formik.touched["country"] && Boolean(formik.errors["country"]), helperText: formik.touched["country"] && formik.errors["country"], label: t("Country"), InputProps: __assign(__assign({}, params.InputProps), { endAdornment: (_jsx(React.Fragment, { children: params.InputProps.endAdornment })) }) }))); }, onChange: function (e, selectedItem) {
                                formik.setFieldValue('country', selectedItem ? selectedItem.alpha2 : []);
                            }, getOptionLabel: function (option) { return "".concat(option.name); } }) }))] })), _jsx(Grid, __assign({ container: true, spacing: 2 }, { children: _jsx(Grid, __assign({ item: true, xs: 6, sx: { minWidth: 300, padding: 2 } }, { children: _jsx(Button, { fullWidth: true, variant: "contained", color: 'success', startIcon: _jsx(PlayIcon, {}), onClick: onSubmit, children: t('Pay') }) })) }))] }));
};
